import './styled.scss';
import { useState, useRef, useEffect } from 'react';
import './styled.scss';
import artComplex01 from 'assets/Desktop/images/parcelOut/cg_birds_view.jpg';
import artComplex02 from 'assets/Desktop/images/parcelOut/cg_perspective.jpg';

import complexLayout01 from 'assets/Desktop/images/parcelOut/danji_cg_01.jpg';
import complexLayout01_big from 'assets/Desktop/images/parcelOut/danji_cg_01_big.jpg';
import complexLayout02 from 'assets/Desktop/images/parcelOut/danji_cg_02.jpg';
import complexLayout02_big from 'assets/Desktop/images/parcelOut/danji_cg_02_big.jpg';
import complexLayout03 from 'assets/Desktop/images/parcelOut/danji_cg_03.jpg';
import complexLayout03_big from 'assets/Desktop/images/parcelOut/danji_cg_03_big.jpg';
import complexLayout04 from 'assets/Desktop/images/parcelOut/danji_cg_04.jpg';
import complexLayout04_big from 'assets/Desktop/images/parcelOut/danji_cg_04_big.jpg';

import mainComplexLayout from 'assets/Desktop/images/parcelOut/danji.jpg';
import mainComplexLayout_big from 'assets/Desktop/images/parcelOut/danji_big.jpg';
import artComplexCommunity01 from 'assets/Desktop/images/parcelOut/community_iso_01.png';
import artComplexCommunity02 from 'assets/Desktop/images/parcelOut/community_iso_02.png';

import artComplexDongho01 from 'assets/Desktop/images/parcelOut/dongho-1.jpg';
import artComplexDongho02 from 'assets/Desktop/images/parcelOut/keymap.png';
import artComplexDongho03 from 'assets/Desktop/images/parcelOut/dongho.png';
import artComplexDongho03_big from 'assets/Desktop/images/parcelOut/dongho_big.png';

import { GetMobileStyledCompImg } from 'common-modules/general/Modules/functions';
import { observer } from 'mobx-react';

import OfferTechnologySlide from './OfferTechnologySlide';
import { listContent, listPromition } from 'data/street';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';

SwiperCore.use([Pagination]);

const dataLayoutSlide = [
  {
    id: 1,
    img: complexLayout01,
    imgBig: complexLayout01_big,
    name: '주출입구'
  },
  {
    id: 2,
    img: complexLayout02,
    imgBig: complexLayout02_big,
    name: '어린이 놀이터'
  },
  {
    id: 3,
    img: complexLayout03,
    imgBig: complexLayout03_big,
    name: '근린생활시설'
  },
  {
    id: 4,
    img: complexLayout04,
    imgBig: complexLayout04_big,
    name: '중앙광장'
  }
];

const Street = observer(() => {
  const popUp = useRef<any>(null);
  const popUpImg = useRef<any>(null);
  const donghoImg = useRef<any>(null);

  const [isLayoutMap, setIsLayoutMap] = useState<Boolean>(true);

  const openPopUp = (popUpName, img?: any) => {
    popUpName.current.style.visibility = 'visible';
    popUpName.current.style.opacity = 1;
    const body = document.getElementsByTagName('body');

    if (body) {
      body[0].classList.add('burgerMenu-open');
    }

    if (img) {
      popUpImg.current.setAttribute('src', img);
    }
  };
  const closePopUp = popUpName => {
    popUpName.current.style.visibility = 'hidden';
    popUpName.current.style.opacity = 0;
    const body = document.getElementsByTagName('body');

    body[0].classList.remove('burgerMenu-open');
  };

  // setup slide
  const slideRef = useRef<any>(null);

  // 220830 add
  interface contentList {
    name: string;
    isActive: boolean;
  }

  const contentList = [
    { name: '특징', isActive: true},
    { name: '단지 배치도', isActive: true},
    { name: '단지 환경', isActive: true},
    { name: '커뮤니티', isActive: true},
    { name: '동호 배치', isActive: true},
    { name: '시스템', isActive: true}
  ];

  return (
    <div className="contents-street-mobile">

      {/* 특징 */}
      {contentList[0].isActive ? (
      <section className="section-info container section-tit pt-60 ">
        <div className="t-center info-header">
          <i className="ico-double-dot"></i>
          <h3 className="title pt-25">
          광주를 대표할 랜드마크 단지답게 단지 곳곳에 적용한 특화 설계와 커뮤니티
          </h3>
          {/* <p className="sub-title pt-10">자녀 교육의 메카, 광주 미래의 중심</p> */}
        </div>
        {/* <div className="info-wrapper">
          {listPromition.map((v, key) => {
            return (
              <div key={key} className="info-box">
                <h4 className="info-box__title"> {v.title} </h4>
                <div className="info-box__content"> {v.desc} </div>
              </div>
            );
          })}
        </div> */}
        <div className="info-image">
          <img
            onClick={() => {
              openPopUp(popUp, artComplex01);
            }}
            src={`${artComplex01}`}
            alt="artComplex01"
          />
          <img
            onClick={() => {
              openPopUp(popUp, artComplex02);
            }}
            src={`${artComplex02}`}
            alt="artComplex02"
          />
        </div>
        <div className="info-message message">
          <p className="desc dash indent">
            * 본 홈페이지 조감도, 투시도는 소비자의 이해를 돕기 위한 것으로 실제와 차이가 날 수 있으며, 건축물의 입면 등 외관 및 색채계획, 창호계획 등은 일부 변경될 수 있습니다.
          </p>
        </div>
      </section>
      ) : null}

      {/* 단지 배치도 */}
      {contentList[1].isActive ? (
      <section className="layout">
        <div className="layout-container">
          <div className="section-title">
            <h2>단지 배치도</h2>
          </div>
          <div className="layout-img">
            <img
              onClick={() => {
                openPopUp(popUp, mainComplexLayout_big);
              }}
              src={mainComplexLayout}
              alt="mainComplexLayout"
            />
          </div>
          <div className="info-message message">
            <p className="desc dash indent">
              * 본 홈페이지 단지 배치도와 단지 주변환경은 소비자의 이해를 돕기 위한 것으로 실제와 차이가 있을 수 있으니 현장에서 자세히 확인하시기 바랍니다.
            </p>
          </div>

          <div className="layout-content">
          <div className="layout-item">
              <h3 className="layout-title">주출입구</h3>
              <p className="layout-sub-title">e편한세상의 시그니처가 적용되어 자부심이 시작되는 공간</p>
            </div>
            <div className="layout-item">
              <h3 className="layout-title">중앙광장</h3>
              <p className="layout-sub-title">넓은 잔디 마당을 조성하여 가슴까지 탁 트이는 자연친화적 공간</p>
            </div>
            <div className="layout-item">
              <h3 className="layout-title">어린이놀이터</h3>
              <p className="layout-sub-title">흥미로운 이야기가 있는 다양한 테마형 어린이놀이터</p>
            </div>
            <div className="layout-item">
              <h3 className="layout-title">주민운동시설</h3>
              <p className="layout-sub-title">주민들의 건강한 야외 활동을 위한 운동시설과 휴게시설을 갖춘 건강 힐링공간</p>
            </div>
          </div>
        </div>
      </section>
      ) : null}

      {/* 단지 환경 */}
      {contentList[2].isActive ? (
      <section className="layout">
        <div className="layout-container">
          <div className="section-title">
            <h3>단지 환경</h3>
          </div>
        </div>
        <div className="layout-slide">
          <Swiper pagination={true} preventClicks={false} slidesPerView={1.1} spaceBetween={20}>
            <div className="layout-slide-wrapper">
              {dataLayoutSlide.map((item, index) => {
                return (
                  <SwiperSlide key={index} className="layout-slide-item">
                    <div className="layout-slide-item-title">{item.name}</div>
                    <img
                      onClick={() => {
                        openPopUp(popUp, item.imgBig);
                      }}
                      className="layout-slide-item-img"
                      src={`${item.img}`}
                      alt={item.img}
                    />
                  </SwiperSlide>
                );
              })}
            </div>
          </Swiper>
        </div>
      </section>
      ) : null}

      {/* 커뮤니티 */}
      {contentList[3].isActive ? (
      <section className="community container">
        <div className="section-title">
          <h2>커뮤니티</h2>
        </div>
        <div className="community-img">
          <img
            onClick={() => {
              openPopUp(popUp, artComplexCommunity01);
            }}
            src={`${artComplexCommunity01}`}
            alt="artComplexCommunity01"
          />
        </div>
        <div className="community-message message">
          <p>
            * 본 이미지는 소비자의 이해를 돕기 위한 것으로 실제와 다를 수 있습니다.
          </p>
        </div>
      </section>
      ) : null}

      {/* 동호배치 */}
      {contentList[4].isActive ? (
      <section className="container dongho">
        <div className="section-title">
          <h2>동호 배치</h2>
        </div>

        <div className="dongho-btn-toggle">
          <div
            onClick={() => {
              setIsLayoutMap(true);
              if (donghoImg && donghoImg.current) {
                donghoImg.current.src = artComplexDongho02;
              }
            }}
            className={`btn ${isLayoutMap ? 'active' : ''}`}>
            <span>동호배치</span>
          </div>
          <div
            onClick={() => {
              setIsLayoutMap(false);
              if (donghoImg && donghoImg.current) {
                donghoImg.current.src = artComplexDongho03;
              }
            }}
            className={`btn ${!isLayoutMap ? 'active' : ''}`}>
            <span>동호수배치도</span>
          </div>
        </div>

        {isLayoutMap ? (
          <>
            <div className="dongho-image">
              <img
                ref={donghoImg}
                src={`${artComplexDongho02}`}
                alt="artComplexDongho02"
                onClick={(e: any) => {
                  openPopUp(popUp, artComplexDongho02);
                }}
              />
            </div>
            <div className="dongho-message message">
              <p>
                * 본 홈페이지 동호 배치도와 주택형 표의 색채는 주택형과 배치도의 이해를 돕기 위한 것으로 실제 시공 시에 달라질 수
                있습니다.
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="dongho-image">
              <img
                ref={donghoImg}
                src={`${artComplexDongho03}`}
                alt="artComplexDongho03"
                onClick={(e: any) => {
                  openPopUp(popUp, artComplexDongho03_big);
                }}
              />
            </div>
          </>
        )}

        <div className="dongho-color">
          <h3 className="dongho-color-header">세대수</h3>
          <div className="dongho-list">
            {listContent.map((contents, idx) => {
              const color_css: string = `color ${contents.color}`;
              return (
                <div key={idx} className="dongho-item">
                  <div className={color_css}></div>
                  <span className="text">{`${contents.tit}(${contents.subtit})`}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      ) : null}

      {/* 시스템 */}
      {contentList[5].isActive ? (
      <section className="system">
        <div className="system-container">
          <div className="section-title">
            <h2>시스템</h2>
          </div>
        </div>
        <div className="system-list-slide">
          <div className="system-slide-safety system-slide-common">
            <OfferTechnologySlide type={1} />
          </div>

          <div className="system-slide-energy-saving system-slide-common">
            <OfferTechnologySlide type={2} />
          </div>

          <div className="system-slide-health system-slide-common">
            <OfferTechnologySlide type={3} />
          </div>

          <div className="system-slide-convenience system-slide-common">
            <OfferTechnologySlide type={4} />
          </div>

          <div className="system-slide-noise system-slide-common">
            <OfferTechnologySlide type={5} />
          </div>
        </div>
        <div className="system-container">
          <div className="system-message message">
            <p>* 본 홈페이지의 시스템 이미지는 입주자의 이해를 돕기 위한 것 으로 실제와 다를 수 있습니다.</p>
          </div>
        </div>
      </section>
      ) : null}

      {/* 팝업 - 기본상황일때는 활성화되지 않으며 특정 상황(이미지 클릭 시)에만 활성화 됩니다. */}
      <div ref={popUp} className="pop-up">
        <div className="pop-up-header">
          <img
            onClick={() => {
              closePopUp(popUp);
            }}
            className="btn-close"
            src={GetMobileStyledCompImg('common/ico_close02.png')}
            alt="icoClose02"
          />
        </div>
        <div>
          <div className="pop-up-img">
            <img ref={popUpImg} src="" alt="DL건설" />
          </div>
        </div>
      </div>
    </div>
  );
});

export default Street;
